import React, { Component } from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export default class Walletfailure extends Component {
  render() {
    return (
      <div>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Grid stackable>
                <Grid.Row>
                  <div
                    style={{ margin: '0 auto', display: 'block' }}
                  ><br /><br /><Icon name='close' size="massive" color="red" /></div>
                </Grid.Row>
                <Grid.Row>
                  <div
                    style={{ margin: '0 auto' }}
                  >
                    <p
                      style={{ fontSize: '50px',
                       textAlign: "center",
                       margin: '0',
                       color: '#666',
                       textTransform: 'uppercase' 
                      }}
                    >Failure</p>
                    <p
                      style={{textAlign: 'center', fontSize: '16px'}}
                    >Transaction Failed. Click <Link to="/accounts">Here</Link> To Go Back</p>
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}
